import { createSelector } from 'reselect';
import { getUserPreference } from '@Selectors/profile/selector/getUserPreference';
import { ProfileView } from '@Selectors/profile/view/ProfileView';
import { VersionGame, VersionInterface } from '@Models';

const presentVersionGame = (item: VersionGame | undefined): string => {
  if (item === undefined) {
    return 'Ninth Age';
  }

  switch (item) {
    case VersionGame.EssenceOfWar:
      return 'Essence of War';
    case VersionGame.WarhammerBattle:
      return 'Warhammer Battle';
    case VersionGame.TheOldWorld:
      return 'The Old World';
  }

  return 'Ninth Age';
};

const presentVersionInterface = (
  item: VersionInterface | undefined,
): string => {
  if (item === undefined) {
    return 'Classic';
  }

  switch (item) {
    case VersionInterface.OldSkool:
      return 'Old Skool';
  }

  return 'Classic';
};

const presentUseLatest = (item: boolean | undefined): string => {
  if (item === undefined) {
    return 'Yes';
  }

  if (!item) {
    return 'No';
  }

  return 'Yes';
};

export const presentProfilePresenter = createSelector(
  [getUserPreference],
  (userPreference): ProfileView => {
    return new ProfileView({
      name: userPreference?.name ?? '',
      game: presentVersionGame(userPreference?.game),
      builderInterface: presentVersionInterface(
        userPreference?.builderInterface,
      ),
      useLatest: presentUseLatest(userPreference?.useLatestVersion),
      isGuest: userPreference?.isGuest ?? true,
      defaultLocale: `menu.languages.${userPreference?.defaultLocale ?? 'en'}`,
    });
  },
);
